import DatePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'


import FpuiDatePicker from './FpuiDatePicker'

export { DatePicker, FpuiDatePicker }
export default { DatePicker, FpuiDatePicker }
